<template>
  <div style="overflow-y: auto" 
    v-if="isPermittedAll([
        'CustomersGetAll'
    ]) && isMobile">
      <v-expansion-panels multiple v-model="expanded" class="custom-expansion">  
        <v-expansion-panel
          v-for="(customer, i) in mobileFilteredCustomers"
        >
          <v-expansion-panel-header>
            <div class="d-flex justify-center">
              <div  v-if="expanded.includes(i) === false">
                <div class="mb-2">
                  <b >{{ customer.CustomerName }}</b>
                </div>
                <div>{{customer.CustomerPhone1}}</div>
              </div>
              <div class="customer-status-dot-cell ml-auto align-self-center">
                <span
                  class="customer-status-dot mr-1" 
                  :class="customer.CustomerStatusColor.CustomerStatusColorName">
                </span>
              </div>
            </div>
          </v-expansion-panel-header>
          <v-expansion-panel-content>
            <div>
              <div>
                <b>Customer</b>
                <p>{{ customer.CustomerName }}</p> 
              </div>
              <div>
                <b>Support Status</b>
                <p v-if="customer.CustomerStatusColor.CustomerStatusColorName == 'red'" class="ended-support-contract">
                    Do Not Support
                </p>
                <p v-else-if="customer.CustomerStatusColor.CustomerStatusColorName != 'red'"></p>
              </div>
              <div>
                <b>Phone</b>
                <p>{{customer.CustomerPhone1}}</p> 
              </div>
              <div>
                <b>Days Left of Support</b>
                <p v-if="customer.CustomerHasSupportContract">
                    {{customer.SupportContractEndUtc | daysUntilDate}} day(s)
                </p>
                <p v-else-if="customer.CustomerHasSupportContract == false"></p>
              </div>    
              <div class="d-flex">
                <div>
                  <b>Last Updated</b>
                  <p>{{customer.LastModifiedBy.TransactUtc | dateAtTime}}</p> 
                </div>
                <v-btn
                  @click="openCustomer(customer.CustomerID)"
                  type="button"
                  color="primary"
                  outlined
                  class="ml-auto align-self-center">
                  View
                </v-btn>
              </div>
            </div>
          </v-expansion-panel-content>
        </v-expansion-panel>
      </v-expansion-panels>
    </div>

  <v-data-table
    v-else-if="isPermittedAll([
      'CustomersGetAll'
    ])"
    id="customers-table"
    class="page-table"
    mobile-breakpoint="-1"
    :headers="customerFields"
    :items="customers"
    item-key="CustomerID"
    dense
    disable-pagination
    hide-default-footer
    fixed-header
    :options="{
      sortBy: ['CustomerName'],
      rowsPerPage: -1,
    }">
    <template
      v-slot:item="row">
      <tr
        class="pointer"
        :class="{
          'hidden-table-row': row.item.CustomerIsDeleted
        }"
        @click="openCustomer(row.item.CustomerID)">
        <td>
          {{row.item.CustomerName}}
        </td>
        <td v-if="row.item.CustomerStatusColor.CustomerStatusColorName == 'red'">
          <p class="ended-support-contract">
            Do Not Support
          </p>
        </td>
        <td v-if="row.item.CustomerStatusColor.CustomerStatusColorName != 'red'">
        </td>
        <td>{{row.item.CustomerPhone1}}</td>
        <td v-if="row.item.CustomerHasSupportContract">
          {{row.item.SupportContractEndUtc | daysUntilDate}} day(s)
        </td>
        <td v-if="row.item.CustomerHasSupportContract == false">
        </td>
        <td>{{row.item.LastModifiedBy.TransactUtc | dateAtTime}}</td>
        <td class="customer-status-dot-cell">
          <div class="d-flex align-center">
            <span
              class="customer-status-dot mr-1"
              :class="row.item.CustomerStatusColor.CustomerStatusColorName">
            </span>
          </div>
        </td>
      </tr>
    </template>
  </v-data-table>
</template>

<script>
export default {
  name: 'CustomersTable',
  props: ['customers'],
  data() {
    return {
      expanded: [],
      customerFields: [
        {
          text: 'Customer',
          value: 'CustomerName',
        },
        {
          text: 'Support Status',
          value: '',
        },
        {
          text: 'Phone',
          value: 'CustomerPhone1',
        },
        {
          text: 'Days Left of Support',
          value: 'SupportContractEndUtc',
        },
        {
          text: 'Last Updated',
          value: 'LastModifiedBy.TransactUtc',
        },
        {
          text: '',
          value: 'CustomerStatusColor.CustomerStatusColorName',
        },
      ],
    };
  },
  methods: {
    openCustomer(CustomerID) {
      this.getCustomer(CustomerID);
      this.$router.push({ name: 'CustomerFormPage', params: { CustomerID } });
    },
  },
  computed: {
    isMobile() {
      return this.$vuetify.breakpoint.smAndDown;
    },
    mobileFilteredCustomers() {
      return this.customers.filter(x => x.CustomerIsDeleted === false)
        .sort((a, b) => a.CustomerName.localeCompare(b.CustomerName));
    }
  },
  created() {
    this.$store.dispatch('getCustomers');
  },
};
</script>
